enum DataQueriesActions {
  UPDATE_SOURCE_QUERIES = '[data-queries] UPDATE_SOURCE_QUERIES'
}
export default DataQueriesActions
